import type { FC } from 'react';
import { memo } from 'react';

export const BulletSeparator: FC = memo(function BulletSeparator() {
  return <div className="w-1 h-1 self-center rounded-full bg-gray-medium" />;
});
